<!-- 公共组件--富信 -->
<template>
  <div class="smsEdit">
    <div v-if="isMediaQualification">
      <div class="adapter" v-if="isAdapter && isShowAdapterBtn" @click="showRightHug">
        查看富信预览效果
      </div>
      <div class="templatePhoneBox clear-float">
        <div class="left-hug">
          <div class="mobile-box">
            <div class="mobile_inner">
              <div class="sms_tab">
                <!-- 标题 -->
                <div @click="tabEdit({ busiType: 'mediaTitle', index: -1 })" :style="{
                  'border-color': tabNow.busiType == 'mediaTitle'
                    ? '#fe4d45'
                    : '#d6d6d6',
                  // 'padding': '6px 10px',
                  'color': tabNow.busiType == 'mediaTitle'
                    ? '#fe4d45'
                    : '#333333',
                }">
                  富信标题
                </div>
                <div @click="tabEdit({ busiType: 'content', index: -2 })" :style="{
                  'border-color': tabNow.busiType == 'content'
                    ? '#fe4d45'
                    : '#d6d6d6',
                  // 'padding': '6px 10px',
                  'color': tabNow.busiType == 'content'
                    ? '#fe4d45'
                    : '#333333',
                }">
                  <span>文本内容</span>
                </div>
                <!-- 主体内容 -->
                <div v-for="(item, index) in templateData.mediaList" :key="'mediaList1'+item.id"
                  @click="tabEdit({ busiType: item.busiType, index: index })" :style="{
                    'border-color': item.show ? '#fe4d45' : '#d6d6d6',
                    // 'padding': '6px 10px',
                    'color': item.show ? '#fe4d45' : '#333333',
                  }">
                  <div v-if="reRender">
                    <div class="text-item">
                      <!--渲染视频/图片/和短信主体-->
                      <div v-if="item.busiType == 20">
                        上传图片
                      </div>
                      <div v-if="item.busiType == 22">
                        上传视频
                      </div>
                      <div v-if="item.busiType == 21">
                        上传音频
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 底部添加按钮 -->
              <div class="btn_box">
                <div @click="addSrc(20)">
                  <div>
                    <img src="../assets/images/添加图片.png" alt="" />
                  </div>
                  <div><span>添加图片</span></div>
                </div>
                <div @click="addSrc(22)">
                  <div>
                    <img src="../assets/images/添加视频.png" alt="" />
                  </div>
                  <div><span>添加视频</span></div>
                </div>
                <div @click="addSrc(21)">
                  <div>
                    <img src="../assets/images/添加音频.png" alt="" />
                  </div>
                  <div><span>添加音频</span></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div style="margin-top: 10px;">
              <span style="color: #999999;"> 当前内容大小：</span><span class="size">{{ templateData.totalSize }}MB</span>
            </div>
          </div>
          <!-- 移动/删除模块按钮 -->
          <div class="move-btn">
            <div v-if="tabNow.index > 0">
              <img src="@/assets/images/上移.png" @click="moveItems(-1)">
              <span style="color: #7F85E9;" @click="moveItems(-1)">上移</span>
            </div>
            <div v-else-if="tabNow.index == 0"><img src="@/assets/images/禁止上移.png"><span style="color: #CCCCCC;">上移</span></div>
            <div v-if="tabNow.index >= 0 && tabNow.index != templateData.mediaList.length - 1">
              <img src="@/assets/images/下移.png" @click="moveItems(1)">
              <span style="color: #7F85E9;" @click="moveItems(1)">下移</span>
            </div>
            <div v-else-if="tabNow.index >= 0"><img src="@/assets/images/禁止下移.png"><span style="color: #CCCCCC;">下移</span></div>
            <div v-if="tabNow.index >= 0">
              <img src="@/assets/images/删除.png" @click="deleteItems">
              <span style="color:#FE4D45;" @click="deleteItems">删除</span>
            </div>
          </div>
          <div class="fixTis" style="margin-top: 5px;">
            <img class="img" src="@/assets/images/提示_黄.png" />
            <div class="desc">
              <p>至少上传一个媒体内容（包括图片、音频和视频）文件且最多不超过5个，所有内容大小不超过1.3M</p>
            </div>
          </div>
        </div>
        <div class="center-hug">
          <!--右边切换-->
          <div class="title" v-if="tabNow.busiType == 'mediaTitle'">
            <span class="span"><span style="color:red;">*</span>富信标题：</span>
            <el-input style="width: 260px;margin-left: 15px;" size="small" @input="renderFn" maxlength="15"
              show-word-limit v-model="templateData.mediaTitle" placeholder="请输入"></el-input>
          </div>
          <div class="content" v-if="tabNow.busiType == 'content'">
            <div class="tips">
              <div><span style="color:red;">*</span>文本内容：</div>
              <div>
                <div style="background-color: #F9FAFB;margin-top: 5px;padding: 10px;position: relative;width: 520px;"
                  v-if="isSource">
                  <img src="@/assets/images/new_icon_reminder1.png" alt=""
                    style="width: 14px;height: 14px;position: absolute;left: 10px;top: 13px;">
                  <div style="margin-left: 22px;">
                    <p>1、仅纯文本，不超过450个字，必须包含链接且最多一个链接；</p>
                    <p>2、文本中自定义短链接原网址绑定为：<span style="color: #108ee9;">{{ templateData.sourceUrl }}</span></p>
                  </div>
                </div>
                <div style="background-color: #F9FAFB;margin-top: 5px;padding: 10px;position: relative;width: 520px;"
                  v-if="!isSource">
                  <img src="@/assets/images/new_icon_reminder1.png" alt=""
                    style="width: 14px;height: 14px;position: absolute;left: 10px;top: 13px;">
                  <div style="margin-left: 22px;">
                    <p>1、仅纯文本，不超过450个字</p>
                  </div>
                </div>
                <div style="margin: 10px 0px;padding:10px;background-color: #F9FAFB;border: 1px solid #EEEEEE;">
                  <el-input type="textarea" @input="renderFn" v-model="templateData.content" :autosize="{ minRows: 6 }"
                    :maxlength="450 - (sendInfoLength - templateData.content.length)" @paste.native="shopLinkCheck($event)">
                  </el-input>
                  <div>
                    已输入<span style="color:#E16735;">{{ sendInfoLength }}</span>个字（含签名）
                  </div>
                </div>
                <div class="topTis" v-if="isSource">
                  <img class="img" src="@/assets/images/提示_黄.png" />
                  <div class="desc">
                    <p>(1) 文本内容插入的短链接会用变量标签#自定义短链接#代替，实际发送时会转换成短链发送；</p>
                    <p>(2) 包含跳转链接的短信内容需满足以下填写规范：动词+页面名+链接 (示例：点击加购x商品详情页> 3.cn/1l-dAxxx)</p>
                    <p>(3)为防止超过文本字数上限，文本计数时短链接以实际的短链字数计算，插入短网址的原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app。</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="tips" style="margin-top: 10px;" v-if="isSource">
              <div style="padding-top: 6px;">&nbsp;辅助工具：</div>
              <div class="tool">
                <p @click.prevent="handleShowShortLink">
                  <i class="iconfont iconbtn_duanwangzhi"></i>
                  插入短网址
                </p>
              </div>
            </div>
          </div>
          <div class="pictures" v-if="tabNow.busiType == 20">
            <span class="span"><span style="color:red;">*</span>上传图片：</span>
            <el-upload class="upload" :action="`/jd-yusms/sms/upload/media-file/${tabNow.busiType}`"
              accept=".jpg,.jpeg,.png" :before-upload="beforeUpload" :on-success="handleUploadSuccess"
              :on-error="handleError" :file-list="fileList" :on-remove="handleRemove" style="position: relative;">
              <el-button size="small"><img src="@/assets/images/上传.png" />点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                <p>支持格式：jpeg、jpg、png</p>
                <p>横版分辨率建议：640px*480px</p>
                <p>竖版分辨率建议：405px*720px</p>
              </div>
            </el-upload>
          </div>
          <div class="video" v-if="tabNow.busiType == 22">
            <span class="span"><span style="color:red;">*</span>上传视频：</span>
            <el-upload class="upload" :action="`/jd-yusms/sms/upload/media-file/${tabNow.busiType}`" accept=".mp4"
              :before-upload="beforeUpload" :on-success="handleUploadSuccess" :on-error="handleError"
              :file-list="fileList" :on-remove="handleRemove">
              <el-button size="small"><img src="@/assets/images/上传.png" />点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                <p>支持格式：mp4</p>
              </div>
            </el-upload>
          </div>
          <div class="video-type" v-if="tabNow.busiType == 22 && !passVideoCheck">
            <i class="el-icon-warning" style="color: #fe4d45; font-size: 18px;"></i>
            <div class="video-type-tips">
              <p>当前视频编码格式非H.264格式，可能导致部分手机无法播放</p>
              <p>视频，建议更换后再进行上传，如有疑问请联系客服</p>
            </div>
          </div>
          <div class="pictures" v-if="tabNow.busiType == 21">
            <span class="span"><span style="color:red;">*</span>上传音频：</span>
            <el-upload class="upload" :action="`/jd-yusms/sms/upload/media-file/${tabNow.busiType}`" accept=".mp3,.wav"
              :before-upload="beforeUpload" :on-success="handleUploadSuccess" :on-error="handleError"
              :file-list="fileList" style="position: relative;" :on-remove="handleRemove">
              <el-button size="small"><img src="@/assets/images/上传.png" />点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                <p>支持格式：mp3、wav</p>
                <p>建议比特率：32kbs，时长60s以内</p>
              </div>
            </el-upload>
          </div>
        </div>
        <!-- 右侧短信预览效果 -->
        <div class="right-hug" v-if="!isShowAdapterBtn && !isShowAdapter">
          <div class="xiao-hug xiao_hug2">
            <div style="margin: 0 auto; width: 256px">
              <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">
                <div class="sms-center">
                  <div class="message-content">
                    <!-- 标题 -->
                    <div>
                      <p style="font-weight: bold;">{{ templateData.mediaTitle }}</p>
                    </div>
                    <!-- 文本内容 -->
                    <div>
                      <p><span v-if="templateData.jdSmsSuffix">【{{ templateData.jdSmsSuffix }}】</span>{{
                        templateData.content || "" }}</p>
                    </div>
                  </div>
                  <div v-if="templateData.mediaList.length != 0">
                    <!-- 多媒体内容 -->
                    <div v-for="item in templateData.mediaList" :key="'mediaList2'+item.id">
                      <!-- 图片 -->
                      <div class="message-content2" v-if="item.busiType == 20 && item.fileUrl">
                        <el-image style="max-width: 190px;border-radius: 6px;" :src="item.fileUrl"
                          :preview-src-list="imgList" :z-index="99999">
                        </el-image>
                      </div>
                      <!-- 音频 -->
                      <div class="message-content3" v-if="item.busiType == 21 && item.fileUrl">
                        <div v-if="!item.isPlay"><img src="@/assets/images/音频播放键.png" @click="playAudio(item)">
                        </div>
                        <div v-else><img src="@/assets/images/音频暂停键.png" @click="pauseAudio(item)"></div>
                        <div><img src="@/assets/images/音频播放条.png"></div>
                        <div>{{ formatTime(item.totalTimes) }}</div>
                      </div>
                      <!-- 视频 -->
                      <div class="message-content2" v-if="item.busiType == 22 && item.fileUrl">
                        <video style="max-width: 190px;border-radius: 6px;" id="myvideo" controlslist="nodownload"
                          ref="curVideo" preload="auto" controls="controls">
                          <source :src="item.fileUrl" type="video/mp4">
                        </video>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="message-content">拒收请回复R</div>
                  </div>
                </div>
              </div>
              <div class="mobile-tips">
                <p>富信预览效果</p>
                <p>以实际收到为准</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 插入短链接 -->
      <insert-short-dialog v-if="insertShortUrlShow" @close="handleCloseShort"></insert-short-dialog>
      <transition name="popup">
        <div class="popup_wrapper" v-show="isShowAdapter">
          <div class="popup" :class="{ 'fade-in': isShowAdapter, 'fade-out': !isShowAdapter }" style="width: 330px;">
            <div class="head">
              <div>
                <img src="@/assets/images/关闭按钮.png" alt="" data-close @click="_close">
              </div>
            </div>
            <div class="main">
              <div class="xiao-hug xiao_hug2">
                <div style="margin: 0 auto; width: 256px">
                  <div class="mobile-box" :style="{ background: 'url(' + mobileScreen + ') no-repeat' }">
                    <div class="sms-center">
                      <div class="message-content">
                        <!-- 标题 -->
                        <div>
                          <p style="font-weight: bold;">{{ templateData.mediaTitle }}</p>
                        </div>
                        <!-- 文本内容 -->
                        <div>
                          <p><span v-if="templateData.jdSmsSuffix">【{{ templateData.jdSmsSuffix }}】</span>{{
                            templateData.content || "" }}</p>
                        </div>
                      </div>
                      <div v-if="templateData.mediaList.length != 0">
                        <!-- 多媒体内容 -->
                        <div v-for="item in templateData.mediaList" :key="'mediaList3'+item.id">
                          <!-- 图片 -->
                          <div class="message-content2" v-if="item.busiType == 20 && item.fileUrl">
                            <el-image style="max-width: 190px;border-radius: 6px;" :src="item.fileUrl"
                              :preview-src-list="imgList" :z-index="99999">
                            </el-image>
                          </div>
                          <!-- 音频 -->
                          <div class="message-content3" v-if="item.busiType == 21 && item.fileUrl">
                            <div v-if="!item.isPlay"><img src="@/assets/images/音频播放键.png" @click="playAudio(item)">
                            </div>
                            <div v-else><img src="@/assets/images/音频暂停键.png" @click="pauseAudio(item)"></div>
                            <div><img src="@/assets/images/音频播放条.png"></div>
                            <div>{{ formatTime(item.totalTimes) }}</div>
                          </div>
                          <!-- 视频 -->
                          <div class="message-content2" v-if="item.busiType == 22 && item.fileUrl">
                            <video style="max-width: 190px;border-radius: 6px;" id="myvideo" controlslist="nodownload"
                              ref="curVideo" preload="auto" controls="controls">
                              <source :src="item.fileUrl" type="video/mp4">
                            </video>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="message-content">拒收请回复R</div>
                      </div>
                    </div>
                  </div>
                  <div class="mobile-tips" style="color: white;">
                    <p>富信预览效果</p>
                    <p>以实际收到为准</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="isMediaQualification == false && white == false">
      <div class="notShow">
        <img src="@/assets/images/未开通富信.png" alt="">
        <p>您还未开通富信营销功能</p>
        <div class="bottom-btn">
          <button class="select" style="width: 136px;" @click.prevent="checkOut">
            查看富信营销案例
          </button>
          <button class="keep" style="width: 150px;" @click.prevent="toSubmit">
            去提交资质申请开通
          </button>
        </div>
      </div>
      <sms-info-template v-if="smsInfoTemplateShow" @close="handleCloseSmsInfo1" :isShow="smsInfoTemplateShow" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// 获取短信签名
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import { getSeller } from "@/api/richSms";
// 短链弹窗
import insertShortDialog from "@/components/insert-short-dialog";
import smsInfoTemplate from "@/components/sms-info-template";

const { Howl, Howler } = require('howler');


import { mediaFileUpload } from '@/api/smsSend'

export default {
  // 与父组件进行双向绑定
  // richMessageData：组件传出的参数
  // 传入的数据格式应与 templateData中一致
  model: {
    prop: 'richMessageData',
    event: 'newValue'
  },
  props: {
    richMessageData: {
      type: Object,
      default: {}
    },
    // 是否需要插入短链
    isSource: {
      type: Boolean,
      default: true
    },
    // 回显数据，组件长时间放置在页面中时，请通过此对象传入回显数据，传递值与richMessageData一致
    returnData: {
    },
    // 是否需要校验富信资质
    isVerification: {
      type: Boolean,
      default: true
    },
    // 是否需要做小屏适配 --- 右侧预览改为弹窗显示
    isAdapter: {
      type: Boolean,
      default: true
    }
  },
  components: {
    insertShortDialog,
    smsInfoTemplate
  },
  data() {
    return {
      passVideoCheck: true, // 判断视频格式是否为 H.264
      templateData: {  // 富信组件传递的参数
        totalSize: 0, // 总大小
        mediaTitle: "", // 短信标题
        content: '', // 文本内容
        mediaList: [], // 富媒体列表
        jdSmsSuffix: '', // 短信签名
        sourceUrl: '', // 原链接
        jdShortLink: '', // 京东短链接
        isMediaQualification: false,
      },
      tabNow: { busiType: "mediaTitle", index: -1 }, // 当前选中的富信内容模块
      reRender: true, // 用于内容模块的显示隐藏
      mobileScreen: require("@/assets/images/mobileScreen.png"), // 预览图地址
      insertShortUrlShow: false, // 短链弹窗
      smsInfoTemplateShow: false, // 查看富信营销案例弹窗
      isMediaQualification: false, // 是否有富信资质
      imgList: [], // 预览图列表
      audioTimer: null, // 音频计数器
      listId: 0, // 没用，用于作key标识
      fileList: [], // 上传文件列表
      white: true, // 页面空白页
      timer: '', // 音频计时器
      medialId: 1, // 音频对象id
      isShowAdapterBtn: false, // 是否显示富信预览效果按钮
      isShowAdapter: false, // 是否显示富信预览效果
      screenWidth: document.body.clientWidth, // 页面宽度
    }
  },
  created() {

  },
  mounted() {
    // 传入参数回显
    this.templateData = {
      totalSize: this.richMessageData.totalSize || 0, // 总大小
      mediaTitle: this.richMessageData.mediaTitle || '',
      content: this.richMessageData.content || '',
      mediaList: this.richMessageData.mediaList || [],
      jdSmsSuffix: this.richMessageData.jdSmsSuffix || '',
      sourceUrl: this.richMessageData.sourceUrl || '',
      jdShortLink: this.richMessageData.jdShortLink || '',
      isMediaQualification: false
    }
    setTimeout(() => {
      getSeller().then(res => {
        if (res.code == 1) {
          // 用户是否有富信资质
          // console.log(res);
          // 判断是否需要校验富信资质
          if (this.isVerification) {
            this.isMediaQualification = res.data.isMediaQualification
          } else {
            // 不需要校验
            this.isMediaQualification = true
            this.templateData.isMediaQualification = true
          }
          this.white = false
        }
      })
    }, 100)

    this.templateData.mediaList.forEach(async item => {
      if (item.busiType == 21) {
        let player = new Audio(item.fileUrl)
        let times = await this.countAudioTime(player)
        item.totalTimes = times
        this.$forceUpdate()
        this.renderFn();
      }
    })
    // console.log(this.templateData);
    this.renderFn();
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  watch: {
    // 用于更改传出的数据
    templateData: {
      immediate: true,
      handler(newValue, oldVal) {
        this.imgList = []
        let ary = []
        newValue.mediaList.forEach(item => {
          // 向外传输的富媒体列表
          if (item.fileUrl) {
            ary.push({
              busiType: item.busiType,
              mulitiFileName: item.mulitiFileName,
              passVideoCheck: item.passVideoCheck,
              fileUrl: item.fileUrl,
              md5: item.md5,
              fileSize: item.fileSize
            })
            if (item.busiType == 20) {
              this.imgList.push(item.fileUrl)
            }
          }
        })
        let obj = {
          mediaTitle: newValue.mediaTitle,
          content: newValue.content,
          totalSize: newValue.totalSize,
          jdSmsSuffix: newValue.jdSmsSuffix,
          sourceUrl: this.templateData.sourceUrl,
          jdShortLink: this.templateData.jdShortLink,
          isMediaQualification: this.templateData.isMediaQualification,
          // isMediaQualification:true,
          mediaList: ary
        }
        this.$emit('newValue', obj)
      },
      deep: true  // 深度监听
    },
    returnData: {
      immediate: true,
      handler(val) {
        // console.log('returnData:', val);
        this.templateData.totalSize = val.totalSize || 0
        this.templateData.mediaTitle = val.mediaTitle || ''
        this.templateData.content = val.content || ''
        this.templateData.mediaList = JSON.parse(JSON.stringify(val.mediaList)) || []
        if (val.jdSmsSuffix) {
          this.templateData.jdSmsSuffix = val.jdSmsSuffix
          this.$nextTick(() => {
            this.templateData.jdSmsSuffix = val.jdSmsSuffix
          })
          console.log(this.templateData);
        }
        this.templateData.sourceUrl = val.sourceUrl || ''
        this.templateData.jdShortLink = val.jdShortLink || ''
        this.templateData.mediaList.forEach(async item => {
          item.id = this.medialId++
          if (item.busiType == 21) {
            // let player = new Audio(item.fileUrl)
            // let times = await this.countAudioTime(player)
            // item.totalTimes = times
            // this.$forceUpdate()
            // this.renderFn();
            item.isPlay = false
            this.audioPlayer(item.fileUrl, item.id)
          }
        })
        this.$nextTick(() => {
          this.tabEdit({ busiType: 'mediaTitle', index: -1 })
        })
        this.$forceUpdate()
        this.renderFn();
      },
      deep: true
    },
    isMediaQualification: {
      immediate: true,
      handler(val) {
        this.templateData.isMediaQualification = val
      }
    },
    screenWidth:{
      immediate: true,
      handler(val) {
        // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(function () {
          // 打印screenWidth变化的值
          // console.log(that.screenWidth)
          if (that.screenWidth <= 1565) {
            if (that.isAdapter) that.isShowAdapterBtn = true;
          } else {
            if (that.isAdapter) that.isShowAdapterBtn = false;
          }
          that.timer = false
        }, 400)
      }
      }
    },
    // screenWidth(val) {
    //   // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
    //   if (!this.timer) {
    //     // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
    //     this.screenWidth = val
    //     this.timer = true
    //     let that = this
    //     setTimeout(function () {
    //       // 打印screenWidth变化的值
    //       // console.log(that.screenWidth)
    //       if (that.screenWidth <= 1360) {
    //         if (that.isAdapter) that.isShowAdapterBtn = true;
    //       } else {
    //         if (that.isAdapter) that.isShowAdapterBtn = false;
    //       }
    //       that.timer = false
    //     }, 400)
    //   }
    // }
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
    sendInfoLength() {
      if (this.templateData.jdSmsSuffix) {
        if (this.templateData.sourceUrl) {
          if (this.templateData.content.match('#自定义短链接#')) {
            console.log(123);
            // 有签名-有短链
            let sourceUrlNumber = 0
            if(this.templateData.sourceUrl.indexOf('item.m.jd.com')!==-1||this.templateData.sourceUrl.indexOf('shop.m.jd.com')!==-1||this.templateData.sourceUrl.indexOf('shopmember.m.jd.com')!==-1){
              sourceUrlNumber = 2
            }
            return (this.templateData.content.length + this.templateData.jdSmsSuffix.length + 2 + sourceUrlNumber + 7)
          } else {
            console.log(2222);
            // 自定义短链被删除
            this.templateData.sourceUrl = ""
            return (this.templateData.content.length + this.templateData.jdSmsSuffix.length + 2)
          }
        } else {
          // 有签名-无短链
          return (this.templateData.content.length + this.templateData.jdSmsSuffix.length + 2)
        }
      } else {
        if (this.templateData.sourceUrl) {
          if (this.templateData.content.match('#自定义短链接#')) {
            // 无签名-有短链
            let sourceUrlNumber = 0
            if(this.templateData.sourceUrl.indexOf('item.m.jd.com')!==-1||this.templateData.sourceUrl.indexOf('shop.m.jd.com')!==-1||this.templateData.sourceUrl.indexOf('shopmember.m.jd.com')!==-1){
              sourceUrlNumber = 2
            }
            return (this.templateData.content.length + 7 + sourceUrlNumber)
          } else {
            this.templateData.sourceUrl = ""
            return (this.templateData.content.length)
          }
        } else {
          // 无签名-无短链
          this.templateData.sourceUrl = ""
          return (this.templateData.content.length)
        }
      }
    },
  },
  beforeDestroy() {
    // 销毁时关闭音频
    this.templateData.mediaList.forEach(item => {
      if (item.busiType == 21 && this['sound' + item.id]) {
        this['sound' + item.id].pause();
      }
    })
  },
  methods: {
    _close(e) {
      this.isShowAdapter = false;
    },
    // 显示短信预览效果
    showRightHug() {
      this.isShowAdapter = !this.isShowAdapter
    },
    // 音频
    audioPlayer(fileUrl, id) {
      let that = this
      let indexs = ''
      that.templateData.mediaList.forEach((item, index) => {
        if (item.id == id) {
          indexs = index
        }
      })
      this['sound' + id] = new Howl({
        src: [fileUrl],
        autoplay: false,
        loop: false,
        volume: 1,
        html5: true,
        preload: true,
        rate: 1,
        onload: async function () {
          // console.log('加载音频');
          let player = new Audio(fileUrl)
          let times = await that.countAudioTime(player)
          that.templateData.mediaList[indexs].totalTimes = times || 0
          that.$forceUpdate()
          that.renderFn();
        },
        onplay() {
          // console.log('播放!');
          that.templateData.mediaList.forEach((item, index) => {
            if (item.id == id) {
              indexs = index
            }
          })
          let times = that.templateData.mediaList[indexs].totalTimes
          that.audioTimer = setInterval(function () {
            times--
            that.templateData.mediaList[indexs].totalTimes = times
            that.$forceUpdate()
            // console.log(that.templateData.mediaList[indexs].totalTimes);
            if (times < 0) {
              clearInterval(that.audioTimer)
            }
          }, 1000)
        },
        onpause() {
          // console.log('暂停');
          clearInterval(that.audioTimer)
        },
        onstop() {
          clearInterval(that.audioTimer)
        },
        onend: async function () {
          // console.log('结束')
          that.templateData.mediaList[indexs].isPlay = false
          clearInterval(that.audioTimer)
          let player = new Audio(fileUrl)
          let times = await that.countAudioTime(player)
          that.templateData.mediaList[indexs].totalTimes = times || 0
          that.$forceUpdate()
        },
      });
    },
    formatTime(secs) {
      let minutes = Math.floor(secs / 60) || 0;
      let seconds = (secs - minutes * 60) || 0;
      return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    },
    // 切换模块
    tabEdit(obj) {
      this.tabNow = obj;
      this.templateData.mediaList.forEach((i) => (i.show = false));
      if (obj.index >= 0) {
        this.templateData.mediaList[obj.index].show = true;
        if (this.templateData.mediaList[obj.index].mulitiFileName) {
          this.fileList = [{ name: this.templateData.mediaList[obj.index].mulitiFileName, url: this.templateData.mediaList[obj.index].fileUrl }]
          this.passVideoCheck = this.templateData.mediaList[obj.index].passVideoCheck
        } else {
          this.fileList = []
          this.passVideoCheck = true
        }
      }
    },
    // 移动模块
    moveItems(diretion) {
      // 当前选中项下标
      let index = this.tabNow.index
      // 当前选中项数据
      let obj = this.templateData.mediaList[index];
      // 当前项与上一项/下一项交换位置
      this.templateData.mediaList[index] = this.templateData.mediaList[
        index + diretion
      ];
      this.templateData.mediaList[index + diretion] = obj;
      // 修改后当前选中项也对应修改
      this.tabNow.index = index + diretion
      this.renderFn();
    },
    // 删除模块
    deleteItems() {
      let index = this.tabNow.index
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let alData = this.templateData.mediaList;
        console.log(alData[index])
        if (alData[index].busiType == 21 && alData[index].fileUrl) {
          this['sound' + alData[index].id].stop()
        }
        alData.splice(index, 1);
        this.tabNow = { busiType: "suffix", index: -1 };
        this.$forceUpdate()
        this.renderFn();
      })
    },
    // 删除已上传文件
    handleRemove(file, fileList) {
      if (fileList.length == 0) {
        let index = this.tabNow.index
        this.templateData.mediaList[index].fileSize = 0
        this.templateData.mediaList[index].mulitiFileName = ''
        this.templateData.mediaList[index].passVideoCheck = true
        this.passVideoCheck = true
        this.templateData.mediaList[index].fileUrl = ''
        this.templateData.mediaList[index].md5 = ''
        if (this.templateData.mediaList[index].busiType == 21) {
          this.templateData.mediaList[index].isPlay = false
          this['sound' + this.templateData.mediaList[index].id].stop()
        }
        this.fileList = []
        this.renderFn();
      }
    },
    // 添加媒体文件
    async addSrc(type) {
      //添加视频或者图片
      let validate = false;
      if (this.templateData.mediaList.length >= 5) {
        this.$message.warning("媒体内容不可超过上限5个"), (validate = true);
      }
      if (validate) {
        return;
      }
      this.templateData.mediaList.push({
        busiType: type,
        fileSize: 0,
        mulitiFileName: "",
        passVideoCheck: true,
        fileUrl: "",
        md5: '',
        id: this.medialId++,
        show: false,
        isPlay: false
      });
    },
    compare(str, ary) {
      let flag = false
      ary.forEach(item => {
        if (str.toLowerCase() == item.toLowerCase()) {
          flag = true
        }
      })
      return flag
    },
    // 上传前校验
    beforeUpload(file) {
      let _this = this;
      // 获取当前剩余可上传文件大小
      let surplusSize = 1363148.8 - (this.templateData.totalSize * 1024 * 1024)
      // console.log(surplusSize);
      // 控制单个文件的上传大小  字节
      if (file.size > 1363148.8) {
        this.$message.info("文件上传失败，所有内容大小不超过1.3M");
        return false;
      }
      // 当上传文件大小大于当前剩余大小
      if (file.size > surplusSize) {
        this.$message.info("文件上传失败，所有内容大小不超过1.3M");
        return false;
      }
      let types1 = ['.jpeg', '.png', '.jpg']
      let types2 = ['.mp4']
      let types3 = ['.mp3', '.wav']
      let type = file.name.substring(file.name.lastIndexOf("."));
      // console.log(type, type == '.mp3');
      // console.log(this.tabNow.busiType, type);
      if (this.tabNow.busiType == 20 && this.compare(type, types1) == false) {
        this.$message.info("所选文件格式不符，请重新选择图片");
        return false;
      } else if (this.tabNow.busiType == 21 && this.compare(type, types3) == false) {
        this.$message.info("所选文件格式不符，请重新选择音频");
        return false;
      } else if (this.tabNow.busiType == 22 && this.compare(type, types2) == false) {
        this.$message.info("所选文件格式不符，请重新选择视频");
        return false;
      }
      // let forms = new FormData();
      // forms.append("file", file);
      // mediaFileUpload(this.tabNow.busiType, forms).then(async res => {
      //   if (res.code == 1) {
      //     console.log(res);
      //     _this.$message.success("上传成功");
      //     _this.templateData.mediaList[_this.tabNow.index].fileSize = res.data.fileSize
      //     _this.templateData.mediaList[_this.tabNow.index].fileUrl = res.data.fileUrl
      //     _this.templateData.mediaList[_this.tabNow.index].md5 = res.data.md5
      //     _this.templateData.mediaList[_this.tabNow.index].mulitiFileName = res.data.mulitiFileName
      //     // 音频需要计算时间
      //     if (res.data.busiType == 21) {
      //       let player = new Audio(res.data.fileUrl)
      //       let times = await this.countAudioTime(player)
      //       _this.templateData.mediaList[_this.tabNow.index].totalTimes = times
      //     }
      //     this.fileList = [{ name: res.data.mulitiFileName, url: res.data.fileUrl }]
      //     _this.renderFn();
      //   }
      // }).catch(res => {
      //   _this.renderFn(); // 解决上传图片后，有时计算总大小的bug
      //   _this.$message.error("上传失败");
      // })
      // return false;
    },
    // 上传成功
    async handleUploadSuccess(res, file, fileList) {
      if (res.code == 1) {
        this.passVideoCheck = res.data.passVideoCheck
        this.templateData.mediaList[this.tabNow.index].fileSize = res.data.fileSize
        this.templateData.mediaList[this.tabNow.index].fileUrl = res.data.fileUrl
        this.templateData.mediaList[this.tabNow.index].md5 = res.data.md5
        this.templateData.mediaList[this.tabNow.index].mulitiFileName = res.data.mulitiFileName
        this.templateData.mediaList[this.tabNow.index].passVideoCheck = res.data.passVideoCheck
        this.templateData.mediaList[this.tabNow.index].id = this.medialId++
        this.fileList = [{ name: res.data.mulitiFileName, url: res.data.fileUrl }]
        // 音频需要计算时间
        if (res.data.busiType == 21) {
          // let player = new Audio(res.data.fileUrl)
          // let times = await this.countAudioTime(player)
          // this.templateData.mediaList[this.tabNow.index].totalTimes = times || 0
          // console.log('vidoe');
          this.audioPlayer(res.data.fileUrl, this.templateData.mediaList[this.tabNow.index].id)
        }
        this.$forceUpdate()
        this.renderFn();
      } else {
        this.renderFn(); // 解决上传图片后，有时计算总大小的bug
        this.$message.error(res.message);
      }
    },
    // 上传失败
    handleError(err) {
      this.renderFn(); // 解决上传图片后，有时计算总大小的bug
      this.$message.error("上传失败");
    },
    // 显示短链弹窗
    handleShowShortLink() {
      this.insertShortUrlShow = true;
    },
    // 关闭短链接
    handleCloseShort(val, obj) {
      this.insertShortUrlShow = false;
      // console.log(val,obj);
      if (val) {
        if (this.templateData.content.match('#自定义短链接#')) {
          this.templateData.sourceUrl = obj.originUrl;
          this.templateData.jdShortLink = obj.shortLink;
          return
        }
        if (this.sendInfoLength >= 435) {
          this.$message.info("短信内容过多，请先删减");
          return
        }
        this.templateData.sourceUrl = obj.originUrl;
        this.templateData.jdShortLink = obj.shortLink;
        this.templateData.content =
          this.templateData.content + '#自定义短链接#';
      }
    },
    // 计算音频的时长
    async countAudioTime(player) {
      while (isNaN(player.duration) || player.duration === Infinity) {
        // 延迟一会 不然网页都卡死
        // console.log('计算时长');
        await new Promise(resolve => setTimeout(resolve, 200));
        // 设置随机播放时间，模拟调进度条
        player.currentTime = 10000000 * Math.random();
      }
      return parseInt(player.duration)
    },
    // 播放音频
    async playAudio(item) {
      this.templateData.mediaList.forEach(val => {
        if (val.busiType == 21 && this['sound' + val.id]) {
          console.log('val', val);
          val.isPlay = false
          this['sound' + val.id].pause();
        }
      })
      item.isPlay = true
      this.$forceUpdate()
      this['sound' + item.id].play();
      // this.play()
    },
    // 暂停
    pauseAudio(item) {
      this.templateData.mediaList.forEach(val => {
        val.isPlay = false
      })
      this.$forceUpdate()
      this['sound' + item.id].pause();
    },
    // 查看富信营销案例
    checkOut() {
      this.smsInfoTemplateShow = true
    },
    // 关闭富信营销案例弹窗
    handleCloseSmsInfo1() {
      this.smsInfoTemplateShow = false
    },
    // 提交资质申请开通
    toSubmit() {
      // 跳转至  后台管理-富信资质
      this.$router.push({ name: 'media_qualification' })
    },
    // 重新渲染模块
    renderFn() {
      // console.log(this.templateData);
      let _this = this;
      if (this.reRender) {
        this.reRender = false;
        this.$nextTick(() => {
          _this.reRender = true;
        });
      }
      let size = 0;
      [
        this.templateData.mediaTitle,
        this.templateData.jdSmsSuffix,
        this.templateData.content,
      ].forEach((i) => {
        let blob = new Blob([i], { type: "text/plain" });
        size += blob.size / 1048576;
      }); //计算文字的大小
      this.templateData.mediaList.forEach(item => {
        size += item.fileSize
      })
      // size += this.templateData.mediaList
      //   .map((i) => (i.busiType == 20 || i.busiType == 22 || i.busiType == 21 ? i.fileSize : 0))
      //   .reduce((total, now) => total + now, 0); //计算文件大小
      this.templateData.totalSize = size.toFixed(2)
    },
  },
}
</script>

<style lang="scss" scoped>
.smsEdit {
  // width: 100%;
  width: 1200px;
  position: relative // min-width: 1000px;
}

.adapter {
  position: absolute;
  left: 220px;
  top: -50px;
  color: #a585e9;
  cursor: pointer;
}

.templatePhoneBox {
  margin: 20px 0;
  margin-left: -30px;
  position: relative;
  display: flex;

  .left-hug {
    width: 300px;
    float: left;
    text-align: center;
    position: relative;

    .mobile-box {
      margin: 0 auto;
      position: relative;
      width: 256px;
      height: 504px;
      background: url("../assets/images/mobileScreen-rich.png") no-repeat;

      .mobile_inner {
        width: 220px;
        height: 430px;
        padding: 5px;
        position: absolute;
        top: 60px;
        left: 18px;
        background: #fff;

        .sms_tab {
          height: 360px;
          overflow: auto;

          &::-webkit-scrollbar {
            display: none;
          }

          >div {
            // padding: 2px 10px;
            padding: 14px 10px;
            // padding-top: 18px;
            border: 1px solid #d6d6d6;
            border-radius: 5px;
            margin-top: 10px;
            cursor: pointer;

          }
        }

        .btn_box {
          margin-top: 10px;
          display: flex;

          img {
            width: 25px;
            height: 25px;
          }

          >div {
            flex: 1;
            display: inline-block;
            cursor: pointer;
            position: relative;
            font-size: 12px;

            >div:nth-child(2) {
              margin-top: -10px;
            }
          }
        }
      }
    }

    .size {
      color: #fe4d45;
    }

    .remind {
      color: #999;
    }

    .move-btn {
      width: 50px;
      position: absolute;
      left: 280px;
      top: 190px;

      >div {
        margin-top: -5px;

        img {
          width: 15px;
          height: 15px;
          position: relative;
          top: 3px;
          margin-right: 4px;
          cursor: pointer;
        }

        span {
          font-size: 12px;
          cursor: pointer;
        }
      }
    }
  }

  .center-hug {
    width: 600px;
    height: 500px;
    float: left;
    // padding-right: 10px;
    overflow: auto;
    margin-left: 30px;

    .pictures {
      display: flex;
    }

    .video {
      display: flex;
    }

    .video-type {
      margin-top: 10px;
      padding-left: 90px;
      display: flex;

      .video-type-tips {
        margin-left: 4px;
        color: red;
        line-height: 18px;
        font-size: 14px;
      }
    }

    .upload {
      margin: 0px 10px;
      display: inline-block;

      .el-button {
        background-color: #FFF6F6 !important;
        border: 1px solid #FE4D45 !important;
        color: #FE4D45 !important;

        &:hover {
          background-color: #ffe5e5 !important;
        }

        &:active {
          background-color: #fff4f4 !important;
        }
      }

      img {
        width: 15px;
        margin-right: 2px;
        position: relative;
        top: 2px;
      }
    }

    .tips {
      display: flex;

      .img {
        display: inline-block;
        position: absolute;
        left: 14px;
        top: 14px;
        width: 14px;
        height: 14px;
        color: #ffffff;
      }

      >div:nth-child(1) {
        width: 90px;
      }

      >div:nth-child(2) {
        font-size: 13px;
        flex: 1;

        p {
          line-height: 20px;
        }

        >p:nth-child(1) {
          margin-top: 6px;
        }
      }
    }
  }

  .right-hug {
    float: left;
    margin-left: 40px;

    .mobile-box {
      width: 256px;
      height: 504px;

      // margin-left: 30px;
      .sms-center {
        height: 355px;
        overflow: auto;
        position: relative;
        top: 75px;
        left: 0;
        overflow: auto;

        // 去除滚动条
        &::-webkit-scrollbar {
          display: none;
        }
      }

      .message-content {
        word-wrap: break-word;
        padding: 6px 10px;
        border-radius: 10px;
        display: inline-block;
        max-width: 190px;
        min-width: 97px;
        font-size: 12px;
        background-color: #E5E6EA;
        line-height: 18px;
        margin-left: 15px;
        text-align: left;
        margin-top: 2px;
      }

      .message-content2 {
        max-width: 190px;
        margin-left: 15px;
        margin-top: 2px;
        padding: 0;
        background-color: #E5E6EA;
        border-radius: 10px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        img {
          max-width: 190px;
          border-radius: 6px;
        }
      }

      .message-content3 {
        background-color: #E5E6EA;
        border-radius: 15px;
        max-width: 136px;
        height: 31px;
        margin-left: 15px;
        margin-top: 2px;
        padding: 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        >div {
          &:nth-child(1) {
            width: 34px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 25px;
              height: 25px;
              cursor: pointer;
            }
          }

          &:nth-child(2) {
            width: 72px;
            display: flex;
            align-items: center;
            padding-left: 4px;

            img {
              width: 28px;
              height: 18px;
            }
          }

          &:nth-child(3) {
            flex: 1;
            color: #ADADAD;
            font-size: 12px;
          }
        }
      }

    }

    .mobile-tips {
      margin-top: 12px;
      font-size: 14px;
      text-align: center;
      color: rgba(51, 51, 51, 1);

      p {
        line-height: 20px;
      }
    }
  }
}

.select {
  width: 98px;
  height: 32px;
  cursor: pointer;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  border-radius: 3px;
  background-color: #fff4f4;

  &:hover {
    color: #fe4d45;
    background-color: #ffe5e5;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}

.keep {
  width: 98px;
  height: 32px;
  margin: 0 10px 0 8px;
  cursor: pointer;
  color: #ffffff;
  border-radius: 3px;
  border: 1px solid #fe4d45;
  background-color: #fe4d45;

  &:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }

  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}

.topTis {
  position: relative;
  color: #333333;
  font-size: 14px;
  background: #fffaee;
  opacity: 1;
  padding: 12px;
  color: #333333;

  .desc {
    display: inline-block;
    margin-left: 23px;
    // width: 300px;
    line-height: 20px;
  }
}

.fixTis {
  position: relative;
  width: 600px;
  line-height: 30px;
  color: #333333;
  font-size: 13px;
  background: #FFFAEE;
  opacity: 1;
  left: 30px;

  .img {
    display: inline-block;
    position: absolute;
    left: 8px;
    top: 8px;
    width: 14px;
    height: 14px;
    color: #ffffff;
  }

  .desc {
    display: inline-block;
    margin-left: 23px;
    line-height: 20px;
  }
}

.tool {
  cursor: pointer;
  display: flex;
  align-items: center;

  p {
    box-sizing: border-box;
    padding: 0 8px !important;
    margin: 0 8px 0 0 !important;
    // width: 98px;
    height: 32px !important;
    line-height: 32px !important;
    font-size: 14px;
    border-radius: 3px;
    background-color: #FFF6F6;
    color: #FE4D45 !important;

    &:hover {
      background: #ffececab;
      color: #FE4D45 !important;
    }

    &:active {
      background: #ffececab;
      color: #FE4D45;
    }
  }
}

.selectBox {
  text-align: right;

  .headCnt {
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  button {
    width: 98px;
    height: 32px;
    line-height: 30px;
    margin-top: 20px;
    text-align: center;
    background: rgba(254, 77, 69, 1);
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
  }
}

.selectTemplet {
  span {
    font-size: 14px;
    color: #7f85e9;
    cursor: pointer;
  }
}

.btnList {
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    cursor: pointer;
  }

  .replaceButtom {
    cursor: pointer;
    color: rgb(127, 133, 233);

    &:hover {
      color: #fe4d45;
    }
  }

  .btnBox {
    display: inline-block;
    position: relative;
    overflow: hidden;
    height: 32px;
    margin-right: 20px;

    .btn {
      width: 114px;
      height: 32px;
      color: #999999;
      border: 1px solid #cccccc;
      padding-left: 15px;
      border-radius: 3px;
      padding-right: 15px;
      cursor: pointer;
    }

    .check {
      position: absolute;
      right: -16px;
      bottom: -16px;
      width: 30px;
      height: 30px;
      // background-color: #FE4D45;
      border-radius: 50%;
    }

    i {
      position: absolute;
      right: 16px;
      bottom: 15px;
      font-size: 10px;
      color: #fff;
    }
  }


}

.notShow {
  position: relative;

  img {
    margin-left: 100px;
    width: 348px;
    height: 348px;
  }

  p {
    position: absolute;
    left: 197px;
    top: 328px;
    color: #999999;
    font-size: 14px;
  }

  .bottom-btn {
    width: 560px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}

.el-upload__tip {
  font-size: 12;
  color: #999999;

  p {
    line-height: 20px;
  }
}

/deep/ .el-upload-list__item {
  transition: none !important
}

@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }

  100% {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
}

.fade-in {
  animation: fade-in .3s ease;
}

.fade-out {
  opacity: 0;
  transform: translate3d(0, -100%, 0);
  animation: fade-out .3s ease;
}

@keyframes popup-mask-fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes popup-mask-fade-out {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.popup-enter {
  animation: popup-mask-fade-in .3s ease;
}

.popup-leave {
  animation: popup-mask-fade-out .1s ease forwards;
  transform: translate3d(0, -10%, 0);
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0;
}

.popup-enter-active {
  animation: popup-mask-fade-in .3s ease;
}

.popup-leave-active {
  animation: popup-mask-fade-out .1s ease forwards;
  transform: translate3d(0, -10%, 0);
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0;
}

.popup_wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.2);
  transition: all .3s;

  .popup {
    position: relative;
    box-sizing: border-box;
    margin: 15vh auto 0;
    // background: #fff;
    border-radius: 6px;
    // box-shadow: 0 1px 3px rgba(0,0,0,.3);
    transition: all .3s;

    .head {
      position: relative;
      height: 40px;

      div {
        position: absolute;
        right: -20px;
        top: 0;

        img {
          width: 30px;
          height: 30px;
          cursor: pointer;
        }
      }
    }

    .main {
      box-sizing: border-box;
      padding: 0 30px 35px;

      .mobile-box {
        width: 256px;
        height: 504px;

        // margin-left: 30px;
        .sms-center {
          height: 355px;
          overflow: auto;
          position: relative;
          top: 75px;
          left: 0;
          overflow: auto;

          // 去除滚动条
          &::-webkit-scrollbar {
            display: none;
          }
        }

        .message-content {
          word-wrap: break-word;
          padding: 6px 10px;
          border-radius: 10px;
          display: inline-block;
          max-width: 190px;
          min-width: 97px;
          font-size: 12px;
          background-color: #E5E6EA;
          line-height: 18px;
          margin-left: 15px;
          text-align: left;
          margin-top: 2px;
        }

        .message-content2 {
          max-width: 190px;
          margin-left: 15px;
          margin-top: 2px;
          padding: 0;
          background-color: #E5E6EA;
          border-radius: 10px;
          box-sizing: border-box;
          display: flex;
          align-items: center;

          img {
            max-width: 190px;
            border-radius: 6px;
          }
        }

        .message-content3 {
          background-color: #E5E6EA;
          border-radius: 15px;
          max-width: 136px;
          height: 31px;
          margin-left: 15px;
          margin-top: 2px;
          padding: 0;
          box-sizing: border-box;
          display: flex;
          align-items: center;

          >div {
            &:nth-child(1) {
              width: 34px;
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                width: 25px;
                height: 25px;
                cursor: pointer;
              }
            }

            &:nth-child(2) {
              width: 72px;
              display: flex;
              align-items: center;
              padding-left: 4px;

              img {
                width: 28px;
                height: 18px;
              }
            }

            &:nth-child(3) {
              flex: 1;
              color: #ADADAD;
              font-size: 12px;
            }
          }
        }

      }

      .mobile-tips {
        margin-top: 12px;
        font-size: 14px;
        text-align: center;
        color: rgba(51, 51, 51, 1);

        p {
          line-height: 20px;
        }
      }
    }
  }
}
</style>